document.addEventListener('DOMContentLoaded', function () {
  const jumpLink = document.querySelector('.jump-to-specs');
  if (jumpLink) {
    jumpLink.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector('.how-specs');
      if (!target) {
        console.warn('Specs section (.how-specs) not found on this page');
        return;
      }
      let offset = 20;
      const stickyHeader = document.querySelector('header');
      if (stickyHeader && getComputedStyle(stickyHeader).position === 'fixed') {
        offset += stickyHeader.offsetHeight;
      }
      const targetY = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    });
  }

  const topBtn = document.getElementById('scroll-to-top');
  if (topBtn) {
    window.addEventListener('scroll', function () {
      topBtn.style.display = window.pageYOffset > 400 ? 'block' : 'none';
    });
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});